<app-loader *ngIf="isDisabled || isPageDisabled"></app-loader>
<div class="card">
    <form class="g-3" name="WeekoffPoliciesForm" (ngSubmit)="Validate(WeekoffPoliciesForm)"
        #WeekoffPoliciesForm="ngForm" novalidate>
        <div class="card-body p-0">
            <div class="card mb-1">
                <div class="card-header">
                    Week Off Policy
                </div>
                <div class="card-body ms-5">
                    <div class="row mb-3">
                        <div class="col-md-2 align-self-center">
                            <label for="RuleName" class="form-label text-label-dark">Policy Name :</label>
                        </div>
                        <div class="col-md-5">
                            <input type="text" class="form-control text-label-light" placeholder="Ex. Policy Name"
                                id="RuleName" name="RuleName" [(ngModel)]="WeekOffPolicyDetail.RuleName"
                                #RuleName="ngModel" maxlength="100" required>
                            <div class="invalid-feedback">
                                Please Enter Policy Name!
                            </div>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-md-2">
                            <label for="EmpType" class="form-label text-label-dark">Employee Type :</label>
                        </div>
                        <div class="col-md-5">
                            <div class="btn-group btn-group-toggle">
                                <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel
                                    *ngIf="(this.WeekOffPolicyDetail.ESS_WeeklyOffPolicyRuleID == 0) || (this.WeekOffPolicyDetail.ESS_WeeklyOffPolicyRuleID > 0 && common.ToLowerCase(WeekOffPolicyDetail.EmpType) == 'front')">
                                    <input class="form-check-input" type="radio" value='FRONT' name="EmpType"
                                        [(ngModel)]="WeekOffPolicyDetail.EmpType" [ngModelOptions]="{standalone: true}"
                                        [disabled]="WeekOffPolicyDetail.ESS_WeeklyOffPolicyRuleID > 0"
                                        (change)="GetApplicability()" required>
                                    Front Office
                                </label>
                                <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel
                                    *ngIf="(this.WeekOffPolicyDetail.ESS_WeeklyOffPolicyRuleID == 0) || (this.WeekOffPolicyDetail.ESS_WeeklyOffPolicyRuleID > 0 && common.ToLowerCase(WeekOffPolicyDetail.EmpType) == 'back')">
                                    <input class="form-check-input" type="radio" value='BACK' name="EmpType"
                                        [(ngModel)]="WeekOffPolicyDetail.EmpType" [ngModelOptions]="{standalone: true}"
                                        [disabled]="WeekOffPolicyDetail.ESS_WeeklyOffPolicyRuleID > 0"
                                        (change)="GetApplicability()" required>
                                    Back Office
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-md-2 align-self-center">
                            <label for="DefaultRegularization" class="form-label text-label-dark">Default Policy
                                :</label>
                        </div>
                        <div class="col-md-5">
                            <div class="btn-group btn-group-toggle">
                                <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel>
                                    <input class="form-check-input" type="radio" [value]=true name="DefaultRule"
                                        [(ngModel)]="WeekOffPolicyDetail.DefaultRule"
                                        [ngModelOptions]="{standalone: true}">
                                    Yes
                                </label>
                                <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel>
                                    <input class="form-check-input" type="radio" [value]=false name="DefaultRule"
                                        [(ngModel)]="WeekOffPolicyDetail.DefaultRule"
                                        [ngModelOptions]="{standalone: true}">
                                    No
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card mb-1">
                <div class="card-body p-0">
                    <table class="customeDatatable table table-bordered">
                        <thead class="table-light">
                            <tr>
                                <th scope="col">Day</th>
                                <th scope="col">1st</th>
                                <th scope="col">2nd</th>
                                <th scope="col">3rd</th>
                                <th scope="col">4th</th>
                                <th scope="col">5th</th>
                            </tr>
                        </thead>
                        <tbody>
                            @for (ESS_WeeklyOffGroupMapping of WeekOffPolicyDetail.ESS_WeeklyOffGroupMapping; track
                            ESS_WeeklyOffGroupMapping.Day; let i = $index) {
                            <tr>
                                <th scope="row">{{ESS_WeeklyOffGroupMapping.Day}}</th>
                                <td>
                                    <select class="form-select" aria-label="HolidayTypes" placeholder="HolidayTypes"
                                        title="HolidayTypes" name="HolidayTypsFirstWeek1{{i}}"
                                        [(ngModel)]="ESS_WeeklyOffGroupMapping.Week1" #CompanyMasterId="ngModel">
                                        <option [value]=null>--Select Weekoff--</option>
                                        <option *ngFor="let HolidayType of HolidayTypes" [value]="HolidayType.Value">
                                            {{HolidayType.Name}}
                                        </option>
                                    </select>
                                </td>
                                <td>
                                    <select class="form-select" aria-label="HolidayTypes" placeholder="HolidayTypes"
                                        title="HolidayTypes" name="HolidayTypsSecondWeek2{{i}}"
                                        [(ngModel)]="ESS_WeeklyOffGroupMapping.Week2" #CompanyMasterId="ngModel">
                                        <option [value]=null>--Select Weekoff--</option>
                                        <option *ngFor="let HolidayType of HolidayTypes" [value]="HolidayType.Value">
                                            {{HolidayType.Name}}
                                        </option>
                                    </select>
                                </td>
                                <td>
                                    <select class="form-select" aria-label="HolidayTypes" placeholder="HolidayTypes"
                                        title="HolidayTypes" name="HolidayTypsThirdWeek3{{i}}"
                                        [(ngModel)]="ESS_WeeklyOffGroupMapping.Week3" #CompanyMasterId="ngModel">
                                        <option [value]=null>--Select Weekoff--</option>
                                        <option *ngFor="let HolidayType of HolidayTypes" [value]="HolidayType.Value">
                                            {{HolidayType.Name}}
                                        </option>
                                    </select>
                                </td>
                                <td>
                                    <select class="form-select" aria-label="HolidayTypes" placeholder="HolidayTypes"
                                        title="HolidayTypes" name="HolidayTypsFourthWeek4{{i}}"
                                        [(ngModel)]="ESS_WeeklyOffGroupMapping.Week4" #CompanyMasterId="ngModel">
                                        <option [value]=null>--Select Weekoff--</option>
                                        <option *ngFor="let HolidayType of HolidayTypes" [value]="HolidayType.Value">
                                            {{HolidayType.Name}}
                                        </option>
                                    </select>
                                </td>
                                <td>
                                    <select class="form-select" aria-label="HolidayTypes" placeholder="HolidayTypes"
                                        title="HolidayTypes" name="HolidayTypsFifthWeek5{{i}}"
                                        [(ngModel)]="ESS_WeeklyOffGroupMapping.Week5" #CompanyMasterId="ngModel">
                                        <option [value]=null>--Select Weekoff--</option>
                                        <option *ngFor="let HolidayType of HolidayTypes" [value]="HolidayType.Value">
                                            {{HolidayType.Name}}
                                        </option>
                                    </select>
                                </td>
                            </tr>
                            }
                        </tbody>
                    </table>
                </div>
            </div>

            <div class="card">
                <div class="card-header">
                    <div class="row">
                        <div class="col">Applicability</div>
                        <div class="col-md-3">
                            <div class="input-group">
                                <div class="input-group-text"><i class="bi bi-search"></i></div>
                                <input type="text" class="form-control" placeholder="Search Here.."
                                    (keyup)="SearchDropdown($any($event.target).value,'Applicability')">
                            </div>
                        </div>
                        <div class="col-auto">
                            <button type="button" class="btn btn-outline-primary" [disabled]="isDisabled"
                                (click)="ButtonApplicabilityDataFilter()"><i class="bi bi-funnel"
                                    *ngIf="!isDisabled"></i>
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                    *ngIf="isDisabled"></span>
                                {{!isDisabled?'Filter':'Loading...'}}</button>
                        </div>
                    </div>
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-2">
                            <div class="btn-group btn-group-toggle d-flex flex-column bg-light">
                                @for (Applicability of Applicabilitys; track Applicability.WebESSApplicabilityMasterID;
                                let i = $index) {
                                <label class="form-check-label text-label-dark px-1" ngbButtonLabel>
                                    <input class="form-check-input" type="radio"
                                        [value]=Applicability.WebESSApplicabilityMasterID
                                        name='WebESSApplicabilityMasterID'
                                        [(ngModel)]="WeekOffPolicyDetail.WebESSApplicabilityId"
                                        [ngModelOptions]="{standalone: true}" (change)="ApplicabilityDataFilter()"
                                        [disabled]="Applicability.WebESSApplicabilityMasterID == 0 && WeekOffPolicyDetail.DefaultRule">
                                    {{Applicability.ApplicabilityName}}

                                    <i *ngIf="Applicability.WebESSApplicabilityMasterID == 3 || Applicability.WebESSApplicabilityMasterID == 4 || Applicability.WebESSApplicabilityMasterID == 8"
                                        class="bi bi-funnel"></i>
                                </label>
                                }
                            </div>
                        </div>
                        <div class="col-md-10">
                            <div class="row">
                                <div class="form-check" *ngIf="ApplicabilityDatas.length > 0">
                                    <input class="form-check-input" type="checkbox" value="" id="SelectAll"
                                        (change)="ApplicabilityCheckAll($event)">
                                    <label for="SelectAll">
                                        Select All
                                    </label>
                                </div>
                            </div>
                            <div class="row">
                                <label
                                    *ngIf="ApplicabilityDatas.length == 0 && WeekOffPolicyDetail.WebESSApplicabilityId > 0">Please
                                    select filter</label>
                                @for (ApplicabilityData of OrderByApplicability(); track
                                ApplicabilityData.ApplicabilityDataID;
                                let i = $index) {
                                <div class="col-md-4">
                                    <div class="form-check" *ngIf="ApplicabilityDatas.length > 0">
                                        <input class="form-check-input" type="checkbox"
                                            id="ChkOut{{ApplicabilityData.ApplicabilityDataID}}"
                                            name="ChkOut{{ApplicabilityData.ApplicabilityDataID}}"
                                            [(ngModel)]="ApplicabilityData.IsCheck">
                                        <label class="form-check-label applicability-font"
                                            for="ChkOut{{ApplicabilityData.ApplicabilityDataID}}">
                                            {{ApplicabilityData.ApplicabilityData}}
                                        </label>
                                    </div>
                                </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card-footer">
            <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                <button type="button" class="btn btn-outline-secondary btn-sm" [disabled]="isDisabled"
                    (click)="close()"><i class="bi bi-x" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Cancel':'Loading...'}}</button>

                <button
                    *ngIf="(this.common.PageRight.IsAdd && this.WeekOffPolicyDetail.ESS_WeeklyOffPolicyRuleID == 0) || (this.common.PageRight.IsEdit && this.WeekOffPolicyDetail.ESS_WeeklyOffPolicyRuleID > 0)"
                    type="submit" class="btn btn-primary" [disabled]="isDisabled"><i class="bi bi-save2"
                        *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Save':'Loading...'}}</button>
            </div>
        </div>
    </form>
</div>